import "animate.css"

export default function Body(){

    

    return (
        <section className="flex shadow flex-col items-start px-[30px] justify-center startBody z-40  w-[100%] h-[100vh]" id='top'>
        
        <div className={`text-left fadeInLeft animate__fadeInLeft animate__animated flex flex-col items-start justify-start`}>
        <div className="bg-[#14e95828] text-[20px] font-[900] expoSpace z-40 rounded-[15px] text-[#14e956] h-[40px] px-[20px] flex flex-row items-center justify-between">
        <span className='animate__wobble animate__animated pr-[10px] animate__infinite'>👋</span><h1>Welcome! I'm Ibrahim </h1> 
        </div>
        <div className="capitalize expoSpace  text-white text-[30px] py-[30px] sm:text-[50px] text-left font-[900]">
            A <span className="cyborg text-[#14e956] ">frontend engineer</span>. i build mobile <br className='hidden sm:block' /> and web applications
        </div>
            
            <div className="expoSpace text-[15px] sm:text-[20px] text-white font-[400]">
                I am a software engineer who specializes in frontend engineering. I work both as a frontend engineer <br className='hidden sm:block' /> and a backend engineer.
                With over 3 years of experience working at startups and as a freelancer <br className='hidden sm:block'/> I work as both a frontend webapp developer and mobile app developer.
                
            </div>
        </div>

        

        </section>
    )
}